import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchProcessedProducts } from '../../../redux/actions/orderProductProcessaction';
import {Link, useNavigate } from 'react-router-dom';
import capitalizeFirstLetter from '../../comman/capitalizeFirstLetter';

export default function AllOrders({statusFilter}) {
    const navigate=useNavigate();
    const dispatch=useDispatch();
    useEffect(() => {
            dispatch(fetchProcessedProducts(statusFilter)); 
    }, [dispatch,statusFilter]);
      
    const {  processedproducts = [], error } = useSelector(
        (state) => state.processProductState
    );
    
    if (!processedproducts) return <p className="text-red-700">Loading order details...</p>;
    
    if (error) return <p className="text-red-500">Product order error: {error}</p>;

  return (
    <div className='py-5 px-0 lg:px-8 xl:px-10'>
    <div className="">
    {processedproducts.length > 0 ? (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
     {processedproducts.map((row,idx)=>{
        const displayedImages = row.items.slice(0, 2);
        const remainingCount = row.items.length - displayedImages.length;
        return(
        <div className="flex flex-row justify-between border border-pink-200 rounded-md p-2 md:p-4 bg-[#fcf8f8]" key={idx}>
            <div className="flex flex-col space-y-1">
                <p className="font-medium text-sm md:text-base xl:text-lg">{row.orderId}</p>
                <p className="text-xs md:text-sm xl:text-base">Quantity : {row.totalItems}</p>
                <div className="flex space-x-2 mt-3">
                    {displayedImages.map((img, i) => (
                    <img
                        key={i}
                        src={img.product.images?.[0]?.image || ""} 
                        alt={img.product.productName || `Product ${i + 1}`}
                        className="w-10 h-10 object-cover rounded-md border"
                    />
                    ))}

                    {remainingCount > 0 && (
                    <div className="flex items-center justify-center text-xs md:text-sm xl:text-base text-black">
                        +{remainingCount} more
                    </div>
                    )}
                </div>
            </div>
            <div className="flex flex-col justify-between items-end text-end">
                <p className="text-xs md:text-sm xl:text-base">
                    Order Date: {new Date(row.createdAt).toLocaleDateString("en-US", 
                    {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                    })}
                </p>
                <p className="text-xs md:text-sm xl:text-base">
                    Status:{" "}
                    <span className=''>
                        {row.status ==="newRequest" ? "Ordered": capitalizeFirstLetter(row.status)}
                    </span>
                </p>
                <button className="text-xs md:text-sm xl:text-base border rounded-md px-2 py-1 text-center  bg-blue-100 text-blue-700 border-blue-700"
                onClick={() => navigate(`/orderdetail/${row.orderId}`,{ state: { activeStep: 1 }})}>
                  View Details
                </button>

            </div>
        </div>
        );
    })}
    </div>
    ) : (
        <div className="text-gray-600 flex flex-col justify-center space-y-4 w-full">
          <p>No orders found for your account.</p>
          <Link to="/">
            <button className="px-4 py-2 bg-[#A63F40] text-white rounded">Explore Products</button>
          </Link>
        </div>
    )}
    </div>
    </div>
  )
}
